// src/lib/dateUtils.js

// 🕒 Стандартний розклад (пн-чт)
export const timeSlotsDefault = [
  '08:00-09:20',
  '09:30-10:50',
  '11:30-12:50',
  '13:00-14:20',
  '14:30-15:50'
];

// 🕒 Розклад на п’ятницю
export const timeSlotsFriday = [
  '08:00-09:20',
  '09:30-10:50',
  '11:00-12:20',
  '12:30-13:50',
  '14:00-15:20'
];

// 🔄 Функція, яка повертає правильний набір слотів залежно від дати
export const getTimeSlotsForDate = (date) => {
  const d = new Date(date);
  const day = d.getDay(); 
  // getDay(): неділя=0, понеділок=1, ..., п’ятниця=5, субота=6
  return day === 5 ? timeSlotsFriday : timeSlotsDefault;
};

// 📅 Форматування дат
export const formatDate = (date) => {
  return new Intl.DateTimeFormat('uk-UA', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(date));
};

export const formatToYYYYMMDD = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getMonthYear = (date) => {
  const d = new Date(date);
  return {
    month: d.getMonth() + 1,
    year: d.getFullYear()
  };
};

export const getMonthName = (monthNumber) => {
  return new Intl.DateTimeFormat('uk-UA', { month: 'long' }).format(
    new Date(2024, monthNumber - 1)
  );
};

// 📌 Групування списку груп у рядки
export const buildGroupRows = (groups, chunkSize = 5) => {
  const sorted = [...groups].sort((a, b) =>
    a.localeCompare(b, 'uk', { sensitivity: 'base' })
  );
  const rows = [];

  for (let i = 0; i < sorted.length; i += chunkSize) {
    rows.push(sorted.slice(i, i + chunkSize));
  }

  return rows;
};
